export default __webpack_public_path__ + "static/media/template-1.849ebfb3.jpg";